import log from './log';
import requireUser, { UserNotFoundError } from './requireUser';
import { ServiceUserUtils } from './serviceUserUtils';
import { setUserStatus } from './userStatus';
import { AgentLoginStatus } from './agentLoginStatus';

export async function applyAgentLoginStatus(
  agentId: string,
  status: AgentLoginStatus,
) {
  let user;
  try {
    user = await requireUser(agentId);
  } catch (err) {
    // Events are broadcast account-wide, so an agent outside this roster is expected.
    if (err instanceof UserNotFoundError) {
      log('rtcs:agent:login-status:unresolved-agent', agentId);
      return;
    }
    throw err;
  }

  setUserStatus({ userId: user.id, status: status.availabilityStatus });
  ServiceUserUtils.setActivityStatus(user, status.activityStatus);
}
